export default __webpack_public_path__ + "static/media/a011-startup-02.f6d2c814.svg";